<agr-dialog [data]="data" (alt)="alt()" (cancel)="cancel()" (confirm)="confirm()">
  <div *ngIf="data.cartEligibleForChange; else cartNotEligible">
    <p>
      {{ 'cart.cart-modal.content.some-not-eligible' | translate: { type: 'cart.cart-order-type.' + data.changeTo } }}
    </p>

    <ul>
      <li *ngFor="let line of data.cartlinesToRemove">{{ line.skuTitle }} - {{ line.quantity }}</li>
    </ul>
  </div>
  <ng-template #cartNotEligible>
    <p>{{ 'cart.cart-modal.content.all-not-eligible' | translate }}</p>
  </ng-template>
</agr-dialog>
